export default __webpack_public_path__ + "static/media/home-dentist-icon-05.bb2c2ea8.svg";